exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".container1,.container3{display:flex;flex-direction:row;justify-content:space-between}.flex-wrapper{height:100vh;display:flex}.bracket-wrapper{margin:auto;width:auto;border-radius:10px;background-color:#fff;overflow:hidden;box-shadow:0 30px 18px -24px rgba(0,0,0,.2);min-width:850px}.bracket-column,.bracket-wrapper{display:flex;flex-direction:column}.bracket-column{justify-content:space-around;align-items:center}.matchup{padding:10px;display:flex;flex-direction:column}.finalMatchup{display:flex;flex-direction:row;justify-content:center;align-items:center;width:100%}.matchup button,.matchup input{margin-top:1px;margin-bottom:1px;border:1px solid green;width:150px}.finalMatchup button{width:200px;height:40px;margin:20px 5px 50px}.submit-button{margin-top:20px}.broken{opacity:.35}.is-dark{opacity:.25}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-5cc34f17","scoped":false,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/Bracket.vue
// module id = 24
// module chunks = 0